module.exports = __webpack_public_path__ + "img/p7.98fd67e3.png";